export default [
	{
    name: 'delete',
    icon: 'fa-trash-alt',
    method: 'removeParent',
    classes: [],
    hoverable: false,
    menu: null,
  },
  {
    name: 'settings',
    icon: 'fa-cog',
    method: 'openMenu',
    classes: [],
    hoverable: true,
    menu: 'social-proof-bubble-menu',
  }
]